import styled from 'styled-components';

export const ScModelPreviewImageWrapper = styled.div`
  align-self: center;
  height: 80%;
`;
